<template>
  <div class="container h-100">
    <div class="content page-main">
      <div class="header table-search">
        <div class="flex flex-justify-sb">
          <el-form
              :model="searchCondition"
              :inline="true"
              size="mini"
              @submit.native.prevent
          >
            <el-form-item label="">
              <el-radio-group v-model="searchCondition.status" @change="onSubmit">
                <el-radio-button label="pending">待提交</el-radio-button>
                <el-radio-button label="reviewing">审核中</el-radio-button>
                <el-radio-button label="approved">已通过</el-radio-button>
                <el-radio-button label="rejected">已拒绝</el-radio-button>
              </el-radio-group>
              <!-- <el-select
                v-model="searchCondition.status"
                placeholder="状态"
                @change="onSubmit"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="待提交" value="pending"></el-option>
                <el-option label="审核中" value="reviewing"></el-option>
                <el-option label="已通过" value="approved"></el-option>
                <el-option label="已拒绝" value="rejected"></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="">
              <el-input
                  v-model="searchCondition.party_b_name"
                  placeholder="乙方名称"
                  @change="onSubmit"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input
                  v-model="searchCondition.applicant"
                  placeholder="申请人"
                  @change="onSubmit"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input
                  v-model="searchCondition.invoice_title"
                  placeholder="发票抬头"
                  @change="onSubmit"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="onSubmit"
              >查询
              </el-button
              >

            </el-form-item>
          </el-form>
          <div>
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">申请开票
            </el-button>
          </div>
        </div>

      </div>
      <div class="table-data">
        <div
            v-loading="loading"
            element-loading-text="数据加载中……"
            element-loading-spinner="el-icon-loading"
            class="default-table"
        >
          <el-table
              ref="tableCommission"
              :data="dataList"
              border
              highlight-current-row
              style="width: 100%"
              @row-dblclick="handleDbClick"
              row-class-name=""
          >
            <el-table-column
                label="序号"
                width="60"
                header-align="center"
                align="center"
            >
              <template slot-scope="{ $index }">
                <span>{{ offset + $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                width="80"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)" size="mini" effect="plain">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="applicant"
                label="申请人"
                width="100"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="party_b_name"
                label="乙方名称"
                width="110"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="customer_name"
                label="客户"
                width="180"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                prop="invoice_title"
                label="发票抬头"
                width="180"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                prop="apply_amount"
                label="申请金额(元)"
                width="120"
                header-align="center"
                align="right"
            >
              <template slot-scope="scope">
                <span class="money">{{ moneyFormat(scope.row.apply_amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="invoice_type"
                label="发票类型"
                width="100"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
                <span>{{ optionTypeFormat('type_options', scope.row.invoice_type) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="tax_number"
                label="税号"
                width="140"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                prop="invoice_content"
                label="发票内容"
                width="200"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                prop="recipient_email"
                label="收件人邮箱"
                width="140"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="invoice_source"
                label="开票来源"
                width="120"
                header-align="center"
            >
              <template slot-scope="scope">
              <span>{{
                  optionTypeFormat('source_options', scope.row.invoice_source)
                }}</span>
              </template>
            </el-table-column>
            <!--          <el-table-column-->
            <!--              prop="nickname"-->
            <!--              label="红人昵称"-->
            <!--              width="120"-->
            <!--              header-align="center"-->
            <!--          >-->
            <!--          </el-table-column>-->
            <!--          <el-table-column-->
            <!--              prop="brand"-->
            <!--              label="品牌"-->
            <!--              width="120"-->
            <!--              header-align="center"-->
            <!--          >-->
            <!--          </el-table-column>-->
            <!--          <el-table-column-->
            <!--              prop="store"-->
            <!--              label="店铺"-->
            <!--              width="120"-->
            <!--              header-align="center"-->
            <!--          >-->
            <!--          </el-table-column>-->
            <!--          <el-table-column-->
            <!--              prop="platform"-->
            <!--              label="平台"-->
            <!--              width="120"-->
            <!--              header-align="center"-->
            <!--          >-->
            <!--          </el-table-column>-->
            <!--          <el-table-column-->
            <!--              prop="invoice_period"-->
            <!--              label="开票区间"-->
            <!--              width="150"-->
            <!--              header-align="center"-->
            <!--          >-->
            <!--          </el-table-column>-->
            <el-table-column
                prop="create_time"
                label="申请时间"
                width="140"
                header-align="center"
                align="center"
            >
              <template slot-scope="{row}">
                <span :title="`修改时间：${row.updated_at}`">{{ row.create_time || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="updated_at"
                label="修改时间"
                width="140"
                header-align="center"
                align="center"
            >
              <template slot-scope="{row}">
                <span>{{ row.updated_at || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="180"
                header-align="center"
                align="center"
                fixed="right"
            >
              <template slot-scope="scope">
                <div class="flex flex-justify-se">
                  <!--                  <el-link type="primary" size="mini" @click="viewDetails(scope.row)"-->
                  <!--                  >查看-->
                  <!--                  </el-link>-->
                  <el-link
                      v-if="showCopyBtn"
                      type="primary"
                      @click="handleCopy(scope.row)"
                  >复制
                  </el-link>
                  <el-link type="primary"
                           @click="handleSubmit(scope.row)"
                           v-if="scope.row.status === 'pending'"
                  >提交审核
                  </el-link>
                  <el-link
                      :disabled="formLoading"
                      type="primary"
                      @click="editItem(scope.row)"
                      v-if="scope.row.status === 'pending'"
                  >修改
                  </el-link>
                  <el-link
                      type="danger"
                      @click="handleDelete(scope.row)"
                      v-if="scope.row.status === 'pending'"
                  >删除
                  </el-link>
                  <el-link
                      type="warning"
                      @click="handleReSubmit(scope.row)"
                      v-if="scope.row.status === 'rejected'"
                  >申请重审
                  </el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: space-between;align-items: center;gap: 5px">
            <div class="bottom-bar">
              <span>总计: {{ dataList.length }} 条记录</span>
            </div>
            <div>
              <Pagination
                  :total="total"
                  :limit.sync="pagingData.per_page"
                  :page.sync="pagingData.page"
                  @pagination="initList"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 申请开票表单对话框 -->
    <el-dialog
        title="开票申请"
        :visible.sync="showFormDialog"
        width="800px"
        :close-on-click-modal="false"
        center
    >
      <el-form
          ref="commissionForm"
          :model="formData"
          :rules="formRules"
          label-width="120px"
          size="small"
          v-loading="formLoading"
          element-loading-text="表单加载中"
          element-loading-spinner="el-icon-loading"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="申请人" prop="applicant">
              <el-input
                  v-model="formData.applicant"
                  placeholder="请输入申请人"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="乙方" prop="party_b_name">
              <el-select
                  v-model="formData.company_id"
                  placeholder="请输入乙方名称"
                  style="width: 100%"
                  @change="changePartyBName"
              >
                <el-option v-for="(option) in optionsMap.company_options" :label="option.value" :value="option.key"
                           :key="option.key"></el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户" prop="customer_id">
              <el-select
                  style="width: 100%"
                  v-model="formData.customer_name"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="handleSearchCustomer"
                  :loading="loading"
                  @change="handleChangeCustomer"
                  clearable
              >
                <el-option
                    v-for="item in customerOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item">
                  <span> {{ item.name }}</span>
                </el-option>
              </el-select>
              <!--              <div>符合条件的客户：{{customerOptions.length}}</div>-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票抬头" prop="invoice_title">
              <!--              <el-input-->
              <!--                  v-model="formData.invoice_title"-->
              <!--                  placeholder="请输入发票抬头"-->
              <!--                  clearable-->
              <!--              ></el-input>-->
              <el-select
                  style="width: 100%"
                  v-model="formData.invoice_title"
                  filterable
                  allow-create
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @change="handleInvoiceTitle"
                  @focus="handleFocus"
                  clearable
              >
                <el-option
                    v-for="item in invoiceTitleOptions"
                    :key="item.id"
                    :label="item.customer_name"
                    :value="item.invoice_title">
                  <span style="float: left"> {{ item.customer_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px"> （抬头：{{
                      item.invoice_title
                    }} / 销售：{{ item.sale || '' }} ）</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请金额" prop="apply_amount">
              <el-input
                  v-model="formData.apply_amount"
                  placeholder="请输入申请金额"
                  type="number"
                  clearable
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型" prop="invoice_type">
              <el-select
                  v-model="formData.invoice_type"
                  placeholder="请选择发票类型"
                  style="width: 100%"
                  clearable
              >
                <el-option v-for="(option) in optionsMap.type_options" :label="option.value" :value="option.key"
                           :key="option.key"></el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税号" prop="tax_number">
              <el-input
                  v-model="formData.tax_number"
                  placeholder="请输入税号"
                  clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票内容" prop="invoice_content">
              <el-select
                  v-model="formData.invoice_content"
                  placeholder="请选择发票内容"
                  style="width: 100%"
                  clearable
              >
                <el-option v-for="(option) in optionsMap.content_options" :label="option.value" :value="option.key"
                           :key="option.key"></el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人邮箱" prop="recipient_email">
              <el-input
                  v-model="formData.recipient_email"
                  placeholder="请输入收件人邮箱"
                  clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票来源" prop="invoice_source">
              <el-select
                  v-model="formData.invoice_source"
                  placeholder="请选择开票来源"
                  style="width: 100%"
                  default-first-option
                  clearable
              >
                <el-option v-for="(option) in optionsMap.source_options" :label="option.value" :value="option.key"
                           :key="option.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="红人昵称" prop="kol_nicknames">
              <div style="display: flex;justify-content: flex-start;gap: 5px;flex-direction: row;flex-wrap: wrap">
                <el-tag
                    :key="tag"
                    v-for="tag in formData.kol_nicknames"
                    closable
                    effect="plain"
                    :disable-transitions="false"
                    @close="handleRemoveArtist(tag)">
                  {{ tag }}
                </el-tag>
                <dia-choose-artists @sure="(_)=>{formData.kol_nicknames = _||[]}" style="margin-bottom: 10px;"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌" prop="brand">
              <el-input
                  v-model="formData.brand"
                  placeholder="请输入品牌"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺" prop="store">
              <el-input
                  v-model="formData.store"
                  placeholder="请输入店铺"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台" prop="platform">
              <el-select
                  v-model="formData.platform"
                  placeholder="请选择平台"
                  multiple
                  style="width: 100%"
              >
                <el-option v-for="(option) in optionsMap.platform_options" :label="option.value" :value="option.value"
                           :key="option.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票区间" prop="invoice_period">
              <el-date-picker
                  v-model="formData.invoice_period"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发票备注栏" prop="remark">
              <el-input
                  v-model="formData.remark"
                  placeholder="请输入发票备注栏信息"
                  maxlength="200"
                  show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="附件上传">
          <!--          :data="{ file_type: 'certificate', folder: 'covenants' }"-->
          <!--          <UploadExcel v-if="showExcelUpload" upload-uri="/api/upload/file_uploader"-->
          <!--                       @imported="handleUploadFile"></UploadExcel>-->

          <el-upload
              action="#"
              :auto-upload="false"
              :on-change="handleFileChange"
              :on-remove="handleRemoveFile"
              :file-list="fileList"
              multiple
              :limit="1"
          >
            <div class="flex">
              <el-tooltip class="item" effect="dark" :content="`最大允许上传个数为 1个，文件不超过 ${fileMaxSize} MB`"
                          placement="top-end">
                <el-button size="small" type="primary" :loading="uploading" :disabled="uploading"
                           icon="el-icon-upload">点击上传
                </el-button>
              </el-tooltip>

              <div slot="tip" style="display: flex;flex-direction: column;" v-show="showUploadView">
                <div
                    style="margin-left: 10px;padding: 0 10px;border-radius: 10px;border: #F2F2F2 1px solid;width: 300px;text-align: left;font-size: 12px">
                  <div>大小：{{ formatFileSize(fileSize) }} <span style="margin-left: 10px"> 上传速度：{{
                      speedFormat
                    }}</span></div>
                </div>
                <div style="width: 400px;">
                  <el-progress :percentage="percentCompleted"></el-progress>
                </div>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showFormDialog = false">取消</el-button>

        <el-button v-if="applyReCheck" type="primary" @click="submitForm" :loading="formSubmitting"
                   :disabled="formSubmitting"
        > {{ formData.id ? '确认申请重审' : '' }}
        </el-button>
        <el-button v-else type="primary" @click="submitForm" :loading="formSubmitting" :disabled="formSubmitting"
        > {{ formData.id ? '保存' : '确认' }}
        </el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  createCommissionInvoice,
  getCommissionInvoicesOptions,
  getCommissionInvoicesList,
  searchCommissionInvoiceTitle,
  searchCommissionArtist,
  updateCommissionInvoiceRecord,
  deleteCommissionInvoiceRecord,
  submitCommissionInvoiceRecord,
  getCommissionInvoiceDetail,
  reSubmitCommissionInvoiceRecord,
  searchCommissionInvoiceCustomer
} from "@/api/bill";
import {unionObjectArrays} from "@/utils/util";
import {numberFormat} from "@/utils/index.js";
import {formatFileSize, uploadFile} from "@/utils/upload";
import DiaChooseArtists from "@/components/SelectDialog/artist.vue";
// import UploadExcel from "@/components/UploadFile/UploadExcel.vue";

export default {
  name: "CommissionInvoice",
  components: {DiaChooseArtists},
  // components: {UploadExcel},
  computed: {
    loginUser() {
      return this.$store.getters.getUser;
    },
  },
  data() {
    return {
      loading: false,
      showCopyBtn: true,
      showExcelUpload: false,

      dataList: [],
      total: 0,
      offset: 0,
      pagingData: {
        per_page: 20,
        page: 1,
      },
      searchCondition: {
        status: "pending",
        party_b_name: "",
        applicant: "",
        invoice_title: "",
      },
      showFormDialog: false,
      formLoading: false,
      formSubmitting: false,

      kolIds: [],
      selectKolOptions: [],
      formData: {
        applicant: "",
        party_b_name: "",
        invoice_title: "",
        apply_amount: "",
        invoice_type: "",
        tax_number: "",
        invoice_content: "",
        recipient_email: "",
        invoice_source: "",
        kol_nicknames: [],
        kol_ids: [],
        brand: "",
        store: "",
        remark: "",
        platform: [],
        invoice_period: [],
        attachment_id: null,//附件ID
      },
      formRules: {
        applicant: [
          {required: true, message: "请输入申请人", trigger: "blur"},
        ],
        party_b_name: [
          {required: true, message: "请输入乙方名称", trigger: "blur"},
        ],
        customer_id: [
          {required: true, message: "客户必选", trigger: "blur"},
        ],
        invoice_title: [
          {required: true, message: "请输入发票抬头", trigger: "blur"},
        ],
        apply_amount: [
          {required: true, message: "请输入申请金额", trigger: "blur"},
        ],
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "change"},
        ],
        tax_number: [
          {required: true, message: "请输入税号", trigger: "blur"},
        ],
        invoice_content: [
          {required: true, message: "请输入发票内容", trigger: "blur"},
        ],
        recipient_email: [
          {required: true, message: "请输入收件人邮箱", trigger: "blur"},
          {type: "email", message: "请输入正确的邮箱地址", trigger: "blur"},
        ],
        invoice_source: [
          {required: true, message: "请选择开票来源", trigger: "change"},
        ],
        kol_nicknames: [
          {required: true, message: "红人必填", trigger: "change"},
        ],
        brand: [
          {required: true, message: "品牌必填", trigger: "change"},
        ],
        platform: [
          {required: true, message: "平台必填", trigger: "change"},
        ],
        invoice_period: [
          {required: true, message: "开票区间", trigger: "change"},
        ],
      },
      fileList: [],
      fileMaxSize: 10,//单位:M
      fileSize: 0,//当前文件大小
      percentCompleted: 0,//上传进度值：0-100
      speed: 0,//上传速度
      speedFormat: '',//上传速度
      uploading: false,//上传中
      showUploadView: false,
      isShowArtistSelect: false,
      optionsMap: {
        "status_options": {
          "pending": {"key": "pending", "value": "待提交"},
          "reviewing": {"key": "reviewing", "value": "审核中"},
          "approved": {"key": "approved", "value": "已通过"},
          "rejected": {"key": "rejected", "value": "已拒绝"}
        },
        "type_options": {
          "spe_invoice": {"key": "spe_invoice", "value": "电子专票"},
          "common_invoice": {"key": "common_invoice", "value": "电子普票"}
        },
        "source_options": {"offline_invoice": {"key": "offline_invoice", "value": "线上结佣线下开票"}},
        "content_options": [
          {
            "value": "文化创意服务/设计服务/视频设计费",
            "key": "文化创意服务/设计服务/视频设计费"
          }, {
            "value": "文化创意服务/设计服务/创意策划费",
            "key": "文化创意服务/设计服务/创意策划费"
          }, {
            "value": "文化创意服务/设计服务/策划服务费",
            "key": "文化创意服务/设计服务/策划服务费"
          }, {"value": "信息技术服务/信息服务费", "key": "信息技术服务/信息服务费"}, {
            "value": "信息技术服务/信息推广费",
            "key": "信息技术服务/信息推广费"
          },
        ],
        "company_options": []
      },
      invoiceTitleOptions: [],
      customerOptions: [],
      artistOptions: [],
      applyReCheck: false,
    };
  },
  created() {
    this.initList();
    this.loadOptions()
  },
  methods: {
    formatFileSize,
    moneyFormat(value) {
      return numberFormat(value, 2, '.', ',', 'round')
    },
    optionTypeFormat(type, val) {
      const optionMap = this.optionsMap[type]
      return optionMap[val].value || val
    },
    getStatusType(status) {
      const typeMap = {
        pending: "warning",
        reviewing: "primary",
        approved: "success",
        rejected: "danger",
      };
      return typeMap[status] || "info";
    },
    getStatusText(status) {
      const textMap = {
        pending: "待提交",
        reviewing: "审核中",
        approved: "已通过",
        rejected: "已拒绝",
      };
      return textMap[status] || status;
    },
    // eslint-disable-next-line no-unused-vars
    handleDbClick(row, column, event) {
      this.viewDetails(row)
    },
    onSubmit() {
      this.initList();
    },
    initList() {
      this.loading = true;
      const searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, this.pagingData);

      // 这里需要调用API获取数据，暂时用模拟数据
      getCommissionInvoicesList(searchCondition).then((res) => {
        this.loading = false;
        if (res.model) {
          this.dataList = res.model.data;
          this.total = res.model.total;
          this.offset = this.pagingData.per_page * (this.pagingData.page - 1);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSearchCondition() {
      const condition = {};
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (this.searchCondition.party_b_name) {
        condition.party_b_name = this.searchCondition.party_b_name;
      }
      if (this.searchCondition.applicant) {
        condition.applicant = this.searchCondition.applicant;
      }
      if (this.searchCondition.invoice_title) {
        condition.invoice_title = this.searchCondition.invoice_title;
      }
      return condition;
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList;
      this.handleUpload(file)
    },
    handleUploadFile(resp) {
      if (resp.model) {
        this.formData.attachment_id = resp.model.id || 0
      }
    },
    handleRemoveFile() {
      this.percentCompleted = 0;
      this.fileSize = 0;
      this.percentCompleted = 0;
      this.formData.attachment_id = 0;
      this.fileList = []

    },
    /**
     * 自定义上传
     * @param file
     * @returns {Promise<void>}
     */
    async handleUpload(file) {
      this.uploading = true
      this.showUploadView = true

      this.percentCompleted = 0;
      this.fileSize = file.size

      const resp = await uploadFile(file, {
        file_field: 'upload_file',
        maxSize: this.fileMaxSize,
        appendData: {
          file_type: 'invoice',
          folder: 'invoice'
        }
      }, this.showUploadProgress)
      if (resp.model) {
        this.formData.attachment_id = resp.model.id || 0

      }
      setTimeout(() => {
        this.uploading = false
        this.showUploadView = false
      }, 500)
    },
    showUploadProgress(fileName, data) {
      this.percentCompleted = data.percentCompleted
      this.speed = data.speed
      this.speedFormat = data.speedFormat
    },
    /**
     * 申请重审-提交表单
     * @param id
     * @returns {Promise<void>}
     */
    async submitReCheck(id) {
      await reSubmitCommissionInvoiceRecord(id).then(() => {
        this.formSubmitting = false;
        this.showFormDialog = false;
      }).catch(() => {
        this.formSubmitting = false;
      });
    },
    submitForm() {
      if (this.formSubmitting)
        return false;

      this.$refs.commissionForm.validate(async (valid) => {
        if (valid) {
          this.formSubmitting = true;
          // console.log(JSON.stringify(this.formData))
          // 这里需要调用API提交数据
          if (this.formData.id) {
            await updateCommissionInvoiceRecord(this.formData.id, this.formData).then(async (data) => {
              if (data.success) {
                this.msgSuccess('保存成功');
                if (this.applyReCheck) {
                  // 申请重审-提交表单
                  await this.submitReCheck(this.formData.id)
                }
              }
              // this.initList();
            }).catch(() => {
              this.formSubmitting = false;
            });


          } else {
            await createCommissionInvoice(this.formData).then((resp) => {
              // this.formSubmitting = false;
              // this.showFormDialog = false;
              if (resp.success) {
                this.msgSuccess('新增成功');
              } else {
                // console.log(resp)
                this.msgError(resp.message || '新增失败');
              }

            }).catch(() => {
              this.formSubmitting = false;
            });
          }
          this.formSubmitting = false;
          this.showFormDialog = false;
          this.initList();

        }
      });
    },
    viewDetails(row) {
      // this.$message.info(`查看详情: ${row.id}`);
      this.$router.push({name: 'commission-invoice-detail', query: {id: row.id}})
    },
    handleAdd() {
      this.kolIds = []
      this.isShowArtistSelect = true
      this.formData = {
        applicant: "",
        party_b_name: "",
        invoice_title: "",
        apply_amount: "",
        invoice_type: "",
        tax_number: "",
        invoice_content: "",
        recipient_email: "",
        invoice_source: "",
        kol_nicknames: [],
        kol_ids: [],
        brand: "",
        store: "",
        platform: "",
        invoice_period: [],
      };
      if (!this.formData.applicant) {
        this.formData.applicant = this.loginUser.name || ''
        this.formData.applicant_id = this.loginUser.id || 0
      }
      this.showFormDialog = true;
    },
    async handleCopy(row) {
      await this.editItem(row)
      // 需要await数据加载完毕后删除ID才能生效
      delete this.formData.id
    },
    async editItem(editRow) {
      this.kolIds = []
      this.isShowArtistSelect = false
      this.applyReCheck = false
      // 修改对象数据重新请求（列表的行数据不完整）
      this.formLoading = true
      this.showFormDialog = true;
      await getCommissionInvoiceDetail(editRow.id).then((result) => {
        this.formLoading = false
        const row = result.model || {};
        // if (row.kol_ids && isArray(row.kol_ids)) {
        //   this.kolIds = row.kol_ids || []
        //   this.artistOptions = row.kol_ids.map((id, idx) => {
        //     const nickname = row.kol_nicknames[idx] || ''
        //     return {id: id, nickname: nickname}
        //   })
        // }

        this.formData = {...row}
        if (row.attachment) {
          this.fileList = [{
            name: row.attachment.title,
            size: row.attachment.size,
          }]
        }
        // this.showFormDialog = true;
      })

    },
    //提交审核
    async handleReSubmit(row) {
      //
      //申请重审
      await this.editItem(row)
      // 提交重审
      this.applyReCheck = true
      // this.$confirm(`【已拒绝的申请重审】(抬头：${row.invoice_title}，金额：${row.apply_amount}), 是否继续?`, '申请重审', {
      //   confirmButtonText: '直接提交重审',
      //   cancelButtonText: '修改后提交重审',
      //   type: 'warning',
      //   center: true
      // }).then(async () => {
      //   await this.submitReCheck(row.id)
      //
      // }).catch(async() => {
      //     //申请重审
      //     await this.editItem(row)
      //     // 提交重审
      //     this.applyReCheck = true
      //     //状态改为审核
      //     // this.formData.status = 'reviewing'
      // });

    },
    loadOptions() {
      // 加载选择
      getCommissionInvoicesOptions().then((res) => {
        // console.log(JSON.stringify(res.model))
        this.optionsMap = res.model || {}
      })
    },
    changePartyBName(val) {
      // console.log(val)
      const option = this.optionsMap.company_options.find(value => value.key === val)
      // console.log(option)
      this.formData.party_b_name = option.value || ''
      this.$notify.info(`选择乙方：${this.formData.party_b_name}(${this.formData.company_id})`)
    },
    handleSearchCustomer(query) {
      if (query !== '') {
        searchCommissionInvoiceCustomer(query).then((result) => {
          this.customerOptions = result.model || [];
        })
      } else {
        this.customerOptions = [];
      }
    },
    handleChangeCustomer(item) {
      this.formData.customer_name = item.name || ''
      this.formData.customer_id = item.id || null
    },
    remoteMethod(query) {
      if (query !== '') {
        searchCommissionInvoiceTitle(query).then((result) => {
          this.invoiceTitleOptions = result.model || [];
        })
      } else {
        this.invoiceTitleOptions = [];
      }
    },
    handleInvoiceTitle(title) {
      const item = this.invoiceTitleOptions.find(value => value.customer_name === title)
      if (item) {
        // console.log(item)
        this.formData.invoice_title = item.invoice_title || ''
        // this.formData.customer_name = item.customer_name || ''
        // this.formData.customer_id = item.customer_id || 0
        this.formData.tax_number = item.tax_id || ''
        this.formData.invoice_content = item.invoice_content || ''
        this.formData.recipient_email = item.invoice_email || ''
        this.formData.invoice_type = item.invoice_type || ''

      } else {
        // this.formData.invoice_title = ''
        // this.formData.customer_id = 0
        // this.formData.customer_name = ''
        this.formData.tax_number = ''
        this.formData.invoice_content = ''
        this.formData.recipient_email = ''
        this.formData.invoice_type = ''
      }

    },
    handleFocus() {
      if (!this.formData.invoice_title) {
        const query = this.formData.customer_name || '公司'
        if (query) {
          searchCommissionInvoiceTitle(query).then((result) => {
            this.invoiceTitleOptions = result.model || [];
          })
        }
      }

    },

    remoteSearchArtistMethod(query) {
      if (query !== '') {
        searchCommissionArtist(query).then((result) => {
          let resultOptions = result.model || [];
          this.artistOptions = unionObjectArrays(this.artistOptions, resultOptions, 'id')
          // this.artistOptions = [...this.artistOptions, ...resultOptions]
        })
      }
    },
    handleRemoveTag(removeId) {
      // console.log("===== handleRemoveTag ===========")
      const obj = this.artistOptions.find(value => value.id == removeId)
      if (obj) {
        const pIndex = this.formData.kol_nicknames.indexOf(obj.nickname)
        if (pIndex > -1) {
          this.formData.kol_nicknames.splice(pIndex, 1)
        }
      }
    },
    handleRemoveArtist(nickname) {
      const pIndex = this.formData.kol_nicknames.indexOf(nickname)
      if (pIndex > -1) {
        this.formData.kol_nicknames.splice(pIndex, 1)
      }
    },
    handleSelectArtist(selectedNicknames) {
      // console.log(selectedNicknames)
      selectedNicknames.forEach((nickname) => {
        if (this.formData.kol_nicknames.indexOf(nickname) === -1)
          this.formData.kol_nicknames.push(nickname)
        this.isShowArtistSelect = false
      })

      // this.formData.kol_nicknames = [...this.formData.kol_nicknames, ...selectedNicknames]

      // console.log("===== handleSelectArtist ===========")
      // if (selectedIds && isArray(selectedIds)) {
      //   selectedIds.map((kolId) => {
      //     const obj = this.artistOptions.find(value => value.id == kolId)
      //     if (obj) {
      //       if (this.formData.kol_ids.indexOf(obj.id) === -1) {
      //         if (obj.id) {
      //           this.formData.kol_ids.push(obj.id)
      //           this.formData.kol_nicknames.push(obj.nickname)
      //         }
      //       }
      //     }
      //   })
      // }

    },
    handleArtistFocus() {
      // const query = ''
      // if (query) {
      //   searchCommissionInvoiceTitle(query).then((result) => {
      //     this.artistOptions = result.model || [];
      //   })
      // }
    },
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该记录(抬头：${row.invoice_title}，金额：${row.apply_amount}), 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCommissionInvoiceRecord(row.id).then((result) => {
          // console.log(result)
          if (result.model) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            const pIndex = this.dataList.findIndex(value => value.id == row.id)
            // console.log('p',pIndex)
            if (pIndex > -1) {
              this.dataList.splice(pIndex, 1)
            }
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //提交审核
    handleSubmit(row) {
      //
      this.$confirm(`此操作将该记录【提交审核】(抬头：${row.invoice_title}，金额：${row.apply_amount}), 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submitCommissionInvoiceRecord(row.id).then((result) => {
          // console.log(result)
          if (result.model) {
            this.$message({
              type: 'success',
              message: '提交成功!',
              showClose: true
            });
            const pIndex = this.dataList.findIndex(value => value.id == row.id)
            // console.log('p',pIndex)
            if (pIndex > -1) {
              this.dataList.splice(pIndex, 1)
            }
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },

  },

};
</script>

<style scoped>
.header {
  background: #fff;
}

.page-footer {
  height: 50px;
  width: 100%;
  position: fixed;
  bottom: 1px;
  background-color: #ffffff;
  opacity: 0.9;
  z-index: 999;
}

.bottom-bar {
  width: 100%;
  text-align: left !important;
  padding: 10px 10px 0 1px;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
}

.money {
  font-weight: bold;
  color: #ff3176;
}
</style>
